import { render, staticRenderFns } from "./static-page.vue?vue&type=template&id=6418f309&scoped=true"
import script from "./static-page.vue?vue&type=script&lang=js"
export * from "./static-page.vue?vue&type=script&lang=js"
import style0 from "./static-page.vue?vue&type=style&index=0&id=6418f309&prod&lang=scss"
import style1 from "./static-page.vue?vue&type=style&index=1&id=6418f309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418f309",
  null
  
)

export default component.exports